<template>
  <div ref="lazy-loadding">
    <slot v-if="isRender"></slot>
  </div>
</template>
<script>
import { getById, clientDetail } from "utils";
export default {
  props: {
    dom: {
      type: Object,
      default: () => {
        return {};
      }
    },
    id: {
      type: String,
      default: ""
    },
    dis:{
      type:Number,
      default:20
    }
  },
  data() {
    return {
      isRender: false,
      scrollWrap: ""
    };
  },
  mounted() {
    const lazyDom = this.$refs["lazy-loadding"];
    const scrollWrap = this.getDom();
    const dis = this.dis;
    const height = clientDetail().h;
    this.scroll(lazyDom, dis, scrollWrap, height);
    if(this.isRender){
      return ;
    }
    scrollWrap.addEventListener("scroll", () => {
      this.scroll(lazyDom, dis, scrollWrap, height);
    });
  },
  methods: {
    scroll(dom, dis, scrollWrap, height) {
      const lazyDetail = dom.getBoundingClientRect();
      if (lazyDetail.top - height + dis <= 0) {
      
        this.isRender = true;
        scrollWrap.removeEventListener("scroll", this.scroll);
      }
    },
    getDom() {
      if (this.id) {
        return getById(this.id);
      } else if (JSON.stringify(this.dom) != "{}") {
        return this.dom;
      } else {
        return document;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/lazy-loading/index.vue